export default {"src":"/_next/static/media/gift-card-holiday.20d79cc1.svg","height":646,"width":859};